// @flow

export const slideUp = (target: HTMLElement, duration: number = 500) => {
    // Setup
    target.style.transition = `${duration}ms ease all`;
    target.style.boxSizing = "border-box";
    target.style.overflow = "hidden";
    target.style.height = `${target.clientHeight}px`;

    requestAnimationFrame(() => {
        // Trigger height to zero
        target.style.height = "0";
        target.style.paddingTop = "0";
        target.style.paddingBottom = "0";
        target.style.marginTop = "0";
        target.style.marginBottom = "0";
        target.style.opacity = "0";

        // Wait for animation to finish
        // Then do cleanup
        setTimeout(() => {
            target.style.display = "none";
            target.style.removeProperty("height");
            target.style.removeProperty("padding-top");
            target.style.removeProperty("padding-bottom");
            target.style.removeProperty("margin-top");
            target.style.removeProperty("margin-bottom");
            target.style.removeProperty("overflow");
            target.style.removeProperty("transition");
            target.style.removeProperty("opacity");
        }, duration);
    });
};

export const slideDown = (target: HTMLElement, duration: number = 500) => {
    // Get the natural display property of the element
    target.style.removeProperty("display");
    const { display: naturalDisplay } = window.getComputedStyle(target);

    // Incase the natural display is none, set it to block
    const newDisplay = naturalDisplay === "none" ? "block" : naturalDisplay;

    // Set to visible
    target.style.display = newDisplay;
    target.style.opacity = "0";

    requestAnimationFrame(() => {
        // Now that the target is visible, calculate it's natural height
        const naturalHeight = target.clientHeight;

        // Target setup
        target.style.boxSizing = "border-box";
        target.style.overflow = "hidden";
        target.style.height = "0";
        target.style.paddingTop = "0";
        target.style.paddingBottom = "0";
        target.style.marginTop = "0";
        target.style.marginBottom = "0";
        target.style.transition = `${duration}ms ease all`;

        requestAnimationFrame(() => {
            // Trigger the animation
            target.style.height = `${naturalHeight}px`;
            target.style.removeProperty("padding-top");
            target.style.removeProperty("padding-bottom");
            target.style.removeProperty("margin-top");
            target.style.removeProperty("margin-bottom");
            target.style.removeProperty("opacity");

            // Wait for animation to complete, then do some cleanup
            setTimeout(() => {
                target.style.removeProperty("height");
                target.style.removeProperty("overflow");
                target.style.removeProperty("transition");
            }, duration);
        });
    });
};

export const slideToggle = (target: HTMLElement, duration: number = 500) => {
    const isClosed = window.getComputedStyle(target).display === "none";
    if (isClosed) {
        slideDown(target, duration);
    }
    slideUp(target, duration);
};

export default {
    slideUp,
    slideDown,
    slideToggle,
};
